module.exports = __webpack_public_path__ + "img/lv3.de89c057.png";